import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestMethod } from "@angular/http";
import { RequestConfig, RestResponse } from "../../../../shared/rest/rest.request";
import { CustomHttp } from "../../../../common/http/custom.http";
import { PageImpl } from "../../../../common/http/PageImpl";
import { TicketTypeRequestView } from "../+tipos-ticket/tipos.service";
import { CategoriaT, TaskCategoria } from '../../+tareas/+categorias/task.categorias.service';
import { NzI18nService ,es_ES} from "ng-zorro-antd";

@Injectable()
export class CategoryService {
    private CREATE_CODE = new RequestConfig("TCA", "application/json", true, RequestMethod.Post, "/tickets/categories");
    private EDIT_CODE = new RequestConfig("TCA", "application/json", true, RequestMethod.Put, "/tickets/categories/{categoryId}");
    private DELETE_CODE = new RequestConfig("TCA", "application/json", true, RequestMethod.Delete, "/tickets/categories/{categoryId}");
    private GET_CODE = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, "/tickets/categories/{categoryId}");
    private GET_PAGE = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, "/tickets/categories");
    private GET_BY_TICKETTYPE = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, "/tickets/categories/type/{idTypeTicket}");
    private GET_ALL = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, "/tickets/categories/all");
    private GET_CATEGORIES = new RequestConfig("TCA", "application/json", true, RequestMethod.Post, "/tickets/categories/find");
    private GET_CATEGORIES_ACTIVE = new RequestConfig("TCA", "application/json", true, RequestMethod.Post, "/tickets/categories/find?active=true");

    private GET_CLOSE_CATEGORY_TICKETTYPE = new RequestConfig('TCA', 'application/json', true, RequestMethod.Get, '/closeCategory/{idTypeTicket}');
    private GET_CLOSE_SUBCATEGORY_TICKETTYPE = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, '/closeSubcategory/{idCloseCategory}');
    private GET_CLOSE_SUBCATEGORY_TICKETTYPE2 = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, '/closeSubcategory/{idCloseCategory}');


    private GET_SUBCATEGORY_ALL = new RequestConfig('TSC', 'application/json', true, RequestMethod.Get, '/subCategory/{idCategory}');
    private SAVE_SUBCATEGORY = new RequestConfig('TSC', 'application/json', true, RequestMethod.Post, '/subCategory');
    private DELETE_CODE_SUBCATEGORY = new RequestConfig("TSC", "application/json", true, RequestMethod.Delete, "/subCategory/{idSubCategory}");


    // gloria
    private GET_ALL_TASK = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, "/task/categories/all");
    constructor(private http: CustomHttp,
        private i18n: NzI18nService) {
            this.i18n.setLocale(es_ES);
    }

    /**
     * Envia una petición a WS para guardar autorizacion
     */
    saveCategory(categoria: Categoria): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_CODE, categoria)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de un autorizacion
     */
    getCategory(ticketCategoryId: number): Observable<Categoria> {
        return this.http.sendRequest(this.GET_CODE, {}, ticketCategoryId)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envía petición a WS para editar datos de autorizacion
     */
    updateCategory(categoria: Categoria): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE, categoria, categoria.ticketCategoryId)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar datos de autorizacion
     */
    deleteCategory(ticketCategoryId: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, ticketCategoryId)
            .catch(error => this.http.handleError(error));
    }

        /**
     * Envia petición al servidor para eliminar datos de autorizacion
     */
    deleteSubCategory(ticketSubCategoryId: number) {
        return this.http.sendRequest(this.DELETE_CODE_SUBCATEGORY, {}, ticketSubCategoryId)
            .catch(error => this.http.handleError(error));
    }

    getAll(active?: boolean): Observable<Array<Categoria>> {
        let body = {};
        if (active === true || active === false) {
            body = {active: active};
        }
        return this.http.sendRequest(this.GET_ALL, body)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    searchCategories(request?: any): Observable<Array<Categoria>> {
        return this.http.sendRequest(this.GET_PAGE, request)
            .map(res => res.json().content)
            .catch(error => this.http.handleError(error));
    }

    getPage(options: any): Observable<PageImpl<Categoria>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getByTicketType(idTicketType: number): Observable<Array<Categoria>> {
        return this.http.sendRequest(this.GET_BY_TICKETTYPE, {}, idTicketType)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getCategories(request: TicketTypeRequestView): Observable<Array<Categoria>> {
        return this.http.sendRequest(this.GET_CATEGORIES, request)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getSubcategories(idCategory: number): Observable<SubCategoria[]> {
        return this.http.sendRequest(this.GET_SUBCATEGORY_ALL, {}, idCategory)
            .map((res) => res.json())
            .catch((error) => this.http.handleError(error));
    }

    saveSubcategory(subcategory: SubCategoria): Observable<any> {
        return this.http.sendRequest(this.SAVE_SUBCATEGORY, subcategory)
            .catch((error) => this.http.handleError(error));
    }
    getCategoriesClose(idTicketType: number): Observable<Array<CloseCategoryView>>{
        return this.http.sendRequest(this.GET_CLOSE_CATEGORY_TICKETTYPE, {}, idTicketType)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    getSubCategoriesClose(idCloseCategory: number): Observable<Array<CloseSubcategoryView>>{
        return this.http.sendRequest(this.GET_CLOSE_SUBCATEGORY_TICKETTYPE, {}, idCloseCategory)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getSubCategoriesClose2(idCloseCategory: number): Observable<Array<CloseSubcategoryView>>{
        return this.http.sendRequest(this.GET_CLOSE_SUBCATEGORY_TICKETTYPE2, {}, idCloseCategory)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
//gloria
    getAllTask(active?: boolean): Observable<Array<TaskCategoria>> {
        let body = {};
        if (active === true || active === false) {
            body = {active: active};
        }
        return this.http.sendRequest(this.GET_ALL_TASK, body)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
}

@Injectable()
export class Categoria {
    active: boolean;
    categoryName: string;
    color: string;
    idTypeTicket: number;
    nameTypeTicket: string;
    ticketCategoryId: number;
}

export class SubCategoria {
    active: boolean;
    color: string;
    idCategory: number;
    idSubcategory: number;
    subcategoryName: string;
}

export class CloseCategoryView{
    active: boolean;
    closeCategoryName:	string;
    color: string;
    idCloseCategory: number;
    idTypeTicket: number;
    nameTypeTicket: string;
    code?:number;
    idOrg?:string;
}

export class CloseSubcategoryView{
    active: boolean;
    closeSubcategoryName: string;
    color: string;
    idCloseCategory: number;
    idCloseSubcategory: number;
}


export class CategoriaTicketAdvanceSearch {
    active: boolean;
    name: string;
    page: number;
    size: number;
    orderColumn: string;
    orderType: string;
}

